module.exports = __webpack_public_path__ + "img/loyalty_point.2ad0f844.png";